var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChat = function SvgChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 18C10.4899 18 10.3203 17.9298 10.1953 17.8047C10.0702 17.6797 10 17.5101 10 17.3333V15.3333H6.33333C5.97971 15.3333 5.64057 15.1929 5.39052 14.9428C5.14048 14.6928 5 14.3536 5 14V7.33333C5 6.97971 5.14048 6.64057 5.39052 6.39052C5.64057 6.14048 5.97971 6 6.33333 6H17.6667C18.0203 6 18.3594 6.14048 18.6095 6.39052C18.8595 6.64057 19 6.97971 19 7.33333V14C19 14.3536 18.8595 14.6928 18.6095 14.9428C18.3594 15.1929 18.0203 15.3333 17.6667 15.3333H13.9333L11.4667 17.8067C11.3333 17.9267 11.1733 18 11 18H10.6667Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chat.0d192aef04e3858a1d9e02f18e68cfcd.svg";